import React, { useContext } from "react";
import BasicSelector from "../Basic/BasicSelector";
import { ViasContext } from "../TcIndexPage";

function Via({ via, changeFieldsMultiple, countIndex }) {

    const vias = useContext(ViasContext);

    const selectVesselType = (_id) => {
        changeFieldsMultiple([
            {
                index: countIndex,
                field: 'via',
                value: vias.find(t => t._id === _id),
            }
        ]);
    }

    return (
        <BasicSelector 
            value={via && via._id}
            dataList={vias}
            onChange={(e, _i, value) => selectVesselType(value)}
            iconStyle={{ display: 'none' }}
            underlineStyle={{ display: 'none' }}
            style={{ fontSize: '10px' }}
            labelStyle={{ padding: 0, top: 'unset' }}
            fields={['name']}
        />  
    );
}

export default React.memo(Via);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/Via.jsx